import { Enum } from "./Enum";

export const E_INVOICE = Object.freeze({
  MAIN: () => `/invoice`,
  BY_ID: (id = ":id") => `/invoice/${id}`,
});

export type INVOICE = Enum<typeof E_INVOICE>;
